<template>
  <div id="app">
    <component :is="'script'" ctype="text/javascript"
      :src="'https://cdn-cookieyes.com/client_data/' + $t('cookieEyes') + '.js'" async v-if="prod">
    </component>
    <app-header v-if="showheader"></app-header>
    <router-view />
    <app-footer v-if="showheader"></app-footer>
    <floating-icons></floating-icons>
  </div>
</template>

<script>

require('waypoints/lib/noframework.waypoints.js')
import header from '@/components/parts/header'
import footer from '@/components/parts/footer'
import CookieLaw from 'vue-cookie-law'

import bannerJuntas from '@/components/parts/banner-juntas'
import bannerajustick from '@/components/parts/banner-ajustick'
import bannervideo from '@/components/parts/banner-video'
import bannercatalogo from '@/components/parts/banner-catalogo'
import floatingIcons from '@/components/parts/floating-icons'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    'app-header': header,
    'app-footer': footer,
    'cookie-law': CookieLaw,
    'banner-juntas': bannerJuntas,
    'banner-ajustick': bannerajustick,
    'banner-video': bannervideo,
    'banner-catalogo': bannercatalogo,
    'floating-icons': floatingIcons,
  },
  data() {
    return {
      prod: location.hostname.includes('dev') == false && location.hostname.includes('localhost') == false
    }
  },
  mounted() {
    this.waypoints();
    this.fetchTips(this.getLanguage);
  },
  watch: {
    '$route': function () {
      let that = this;
      setTimeout(function () {
        that.waypoints();
      }, 100);
      document.oncontextmenu = function () { return true; }
    }
  },
  computed: {
    ...mapGetters(['getLanguage']),
    showheader() {
      let routes = ["bonos-ajusa"];
      let show = !routes.find(e => e == this.$route.name);
      return show;
    }
  },
  methods: {
    ...mapActions({
      fetchTips: 'fetchTips'
    }),
    waypoints: function () {
      $(".waypoints-instant").addClass('animated fadeInUp');
      var waypoints = document.getElementsByClassName('waypoints');
      for (var i = 0; i < waypoints.length; i++) {
        new Waypoint({
          element: waypoints[i],
          offset: '100%',
          handler: function () {
            var element = this.key.split('-')[1];
            var effect = this.element.attributes.getNamedItem('data');
            (effect != undefined) ? effect = effect.value : effect = "fadeIn";
            this.element.classList.add("animated", effect)
          }
        });

      }

    }

  }
}
</script>

<style>
@import './assets/css/styles.css';
@import './assets/css/infografia_historia.css';
@import './assets/css/slick.css';
@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700');
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
@import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
</style>


// WEBPACK FOOTER //
// src/App.vue